import alt from 'components/Dispatcher';
import UserActions from 'actions/UserActions';
import UserSource from 'sources/UserSource';

export class UserStore {

  constructor() {
    let lsToken = localStorage.getItem('accessToken') === 'undefined' ? null : localStorage.getItem('accessToken');
    let cookieToken = document.cookie.replace(/(?:(?:^|.*;\s*)accessToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    this.state = {
      user_id: null,
      user: null,
      accessToken: lsToken || cookieToken || null,
      email: '',
      password: '',
      captcha: '',
      errMsg: '',
      captchaKey: null,
      captchaImage: null,
      userInfo: {},
      first: 0,
      maxCount: 20,
      agent: {},
      postAgent: {},
      paidMedias: [],
      publishMedias: [],
      collectMedias: [],
      publishAlbums: [],
      collectAlbums: [],
      agentArticles: [],
      following: [],
      followed: [],
      wants: [],
      links: [],
      paidMediasLoading: false,
      paidMediasHasMore: true,
      publishMediasLoading: false,
      publishMediasHasMore: true,
      collectMediasLoading: false,
      collectMediasHasMore: true,
      publishAlbumsLoading: false,
      publishAlbumsHasMore: true,
      collectAlbumsLoading: false,
      collectAlbumsHasMore: true,
      agentArticlesLoading: false,
      agentArticlesHasMore: true,
      followingLoading: false,
      followingHasMore: true,
      wantsLoading: false,
      wantsHasMore: true,
      linksLoading: false,
      linksHasMore: true,
      followedLoading: false,
      followedHasMore: true
    };
    this.registerAsync(UserSource);
    this.bindListeners({
      handlePostAgent: UserActions.POST_AGENT,
      handleFetchAgent: UserActions.FETCH_AGENT,
      handleFetchAgentArticles: UserActions.FETCH_AGENT_ARTICLES,
      handleUpdateAgent: UserActions.UPDATE_AGENT,
      handleUpdateAgentArticles: UserActions.UPDATE_AGENT_ARTICLES,
      handleClearArticles: UserActions.CLEAR_ARTICLES,
      handleFetchCaptcha: UserActions.FETCH_CAPTCHA,
      handleUpdateCaptcha: UserActions.UPDATE_CAPTCHA,
      handleLogin: UserActions.LOGIN,
      handleRegist: UserActions.REGIST,
      handleForget: UserActions.FORGET,
      handleUpdateUser: UserActions.UPDATE_USER,
      handleUpdateToken: UserActions.UPDATE_TOKEN,
      handleFetchUser: UserActions.FETCH_USER,
      handleUpdateErrMsg: UserActions.UPDATE_ERR_MSG,
      handlePostUserInfo: UserActions.POST_USER_INFO,
      handleFetchPaidMedias: UserActions.FETCH_PAID_MEDIAS,
      handleUpdatePaidMedias: UserActions.UPDATE_PAID_MEDIAS,
      handleFetchPublishMedias: UserActions.FETCH_PUBLISH_MEDIAS,
      handleUpdatePublishMedias: UserActions.UPDATE_PUBLISH_MEDIAS,
      handleFetchCollectMedias: UserActions.FETCH_COLLECT_MEDIAS,
      handleUpdateCollectMedias: UserActions.UPDATE_COLLECT_MEDIAS,
      handleFetchPublishAlbums: UserActions.FETCH_PUBLISH_ALBUMS,
      handleUpdatePublishAlbums: UserActions.UPDATE_PUBLISH_ALBUMS,
      handleFetchCollectAlbums: UserActions.FETCH_COLLECT_ALBUMS,
      handleUpdateCollectAlbums: UserActions.UPDATE_COLLECT_ALBUMS,
      handleFetchFollowing: UserActions.FETCH_FOLLOWING,
      handleFetchWants: UserActions.FETCH_WANTS,
      handleFetchLinks: UserActions.FETCH_LINKS,
      handleFetchFollowed: UserActions.FETCH_FOLLOWED,
      handleUpdateFollowing: UserActions.UPDATE_FOLLOWING,
      handleUpdateWants: UserActions.UPDATE_WANTS,
      handleUpdateLinks: UserActions.UPDATE_LINKS,
      handleUpdateFollowed: UserActions.UPDATE_FOLLOWED,
      handlePostFollow: UserActions.POST_FOLLOW,
      handleUpdateUserFollowing: UserActions.UPDATE_USER_FOLLOWING,
      handleSetLoading: UserActions.SET_LOADING,
      handleClearData: UserActions.CLEAR_DATA,
      handleClearError: UserActions.CLEAR_ERROR
    });
  }
  handleClearError() {
    this.setState({
      errMsg: ''
    })
  }
  handlePostAgent(agent){
    this.state.postAgent = agent
    this.getInstance().postAgent();
  }
  handleFetchAgent(id){
    if(id) {
      this.setState({user_id: id});
    } else {
      this.setState({user_id: null});
    }
    this.getInstance().fetchAgent();
  }
  handleFetchAgentArticles(){
    let first = this.state.agentArticles.length ? this.state.agentArticles.length + 1 : 0;
    this.setState({first: first, agentArticlesLoading: true});
    this.getInstance().fetchAgentArticles();
  }
  handleUpdateAgent(agent){
    this.setState({
      agent: agent
    })
  }
  handleUpdateAgentArticles(articles){
    let more = articles.length === this.state.maxCount;
    let list = this.state.agentArticles.concat(articles);
    this.setState({agentArticles: list, agentArticlesLoading: false, agentArticlesHasMore: more}); 
  }
  handleClearArticles() {
    this.setState({agentArticles: []})
  }
  handleFetchCaptcha() {
    this.getInstance().fetchCaptcha();
  }
  handleUpdateCaptcha(captcha) {
    this.setState(captcha);
  }
  handleLogin(state) {
    this.setState(state);
    this.getInstance().login();
  }
  handleRegist(state) {
    this.setState(state);
    this.getInstance().regist();
  }
  handleForget(state) {
    this.setState(state);
    this.getInstance().forget();
  }
  handleFetchUser(id) {
    if(id) {
      this.setState({user_id: id});
    } else {
      this.setState({user_id: null});
    }
    this.getInstance().fetchUser();
  }
  handleUpdateUser(user) {
    this.setState({
      user: user,
      user_id: user._id
    });
  }
  handleUpdateToken(token) {
    if(token) {
      this.setState({accessToken: token});
    } else {
      this.setState({accessToken: null}); // logout
    }
  }
  handleUpdateErrMsg(errMsg) {
    this.setState({errMsg: errMsg});
  }
  handlePostUserInfo(userInfo){
    this.setState({userInfo: userInfo});
    this.getInstance().postUserInfo();
  }
  handleFetchPaidMedias(id) {
    let first = this.state.paidMedias.length ? this.state.paidMedias.length + 1 : 0;
    this.setState({first: first, paidMediasLoading: true});
    if(id) {
      this.setState({user_id: id});
    } else {
      this.setState({user_id: null});
    }
    this.getInstance().fetchPaidMedias();
  }
  handleUpdatePaidMedias(medias) {
    let more = medias.length === this.state.maxCount;
    let list = this.state.paidMedias.concat(medias);
    this.setState({paidMedias: list, paidMediasHasMore: more, paidMediasLoading: false});
  }
  handleFetchPublishMedias(id) {
    let first = this.state.publishMedias.length ? this.state.publishMedias.length + 1: 0;
    this.setState({first: first, publishMediasLoading: true});
    if(id) {
      this.setState({user_id: id});
    } else {
      this.setState({user_id: null});
    }
    this.getInstance().fetchPublishMedias();
  }
  handleUpdatePublishMedias(medias) {
    let more = medias.length === this.state.maxCount;
    let list = this.state.publishMedias.concat(medias);
    this.setState({publishMedias: list, publishMediasHasMore: more, publishMediasLoading: false});
  }
  handleFetchCollectMedias(id) {
    let first = this.state.collectMedias.length ? this.state.collectMedias.length + 1 : 0;
    this.setState({first: first, collectMediasLoading: true});
    if(id) {
      this.setState({user_id: id});
    } else {
      this.setState({user_id: null});
    }
    this.getInstance().fetchCollectMedias();
  }
  handleUpdateCollectMedias(medias) {
    let more = medias.length === this.state.maxCount;
    let list = this.state.collectMedias.concat(medias);
    this.setState({collectMedias: list, collectMediasHasMore: more, collectMediasLoading: false});
  }
  handleFetchPublishAlbums(id) {
    let first = this.state.publishAlbums.length ? this.state.publishAlbums.length + 1 : 0;
    this.setState({first: first, publishAlbumsLoading: true});
    if(id) {
      this.setState({user_id: id});
    } else {
      this.setState({user_id: null});
    }
    this.getInstance().fetchPublishAlbums();
  }
  handleUpdatePublishAlbums(albums) {
    let more = albums.length === this.state.maxCount;
    let list = this.state.publishAlbums.concat(albums);
    this.setState({publishAlbums: list, publishAlbumsHasMore: more, publishAlbumsLoading: false});
  }
  handleFetchCollectAlbums(id) {
    let first = this.state.collectAlbums.length ? this.state.collectAlbums.length + 1 : 0;
    this.setState({first: first, collectAlbumsLoading: true});
    if(id) {
      this.setState({user_id: id});
    } else {
      this.setState({user_id: null});
    }
    this.getInstance().fetchCollectAlbums();
  }
  handleUpdateCollectAlbums(albums) {
    let more = albums.length === this.state.maxCount;
    let list = this.state.collectAlbums.concat(albums);
    this.setState({collectAlbums: list, collectAlbumsHasMore: more, collectAlbumsLoading: false});
  }
  handleFetchFollowing(id) {
    let first = this.state.following.length ? this.state.following.length + 1 : 0;
    this.setState({first: first, followingLoading: true});
    if(id) {
      this.setState({user_id: id});
    } else {
      this.setState({user_id: null});
    }
    this.getInstance().fetchFollowing();
  }
  handleFetchWants(id) {
    let first = this.state.wants.length ? this.state.wants.length + 1 : 0;
    this.setState({first: first, wantsLoading: true});
    if(id) {
      this.setState({user_id: id});
    } else {
      this.setState({user_id: null});
    }
    this.getInstance().fetchWants();
  }
  handleFetchLinks(id) {
    let first = this.state.links.length ? this.state.links.length + 1 : 0;
    this.setState({first: first, linksLoading: true});
    if(id) {
      this.setState({user_id: id});
    } else {
      this.setState({user_id: null});
    }
    this.getInstance().fetchLinks();
  }
  handleFetchFollowed(id) {
    let first = this.state.followed.length ? this.state.followed.length + 1 : 0;
    this.setState({first: first, followedLoading: true});
    if(id) {
      this.setState({user_id: id});
    } else {
      this.setState({user_id: null});
    }
    this.getInstance().fetchFollowed();
  }
  handleUpdateFollowing(following) {
    let more = following.length === this.state.maxCount;
    let list = this.state.following.concat(following);
    this.setState({
      following: list,
      followingHasMore: more,
      followingLoading: false
    });
  }
  handleUpdateWants(wants) {
    let more = wants.length === this.state.maxCount;
    let list = this.state.wants.concat(wants);
    this.setState({
      wants: list,
      wantsHasMore: more,
      wantsLoading: false
    });
  }
  handleUpdateLinks(links) {
    let more = links.length === this.state.maxCount;
    let list = this.state.links.concat(links);
    this.setState({
      links: list,
      linksHasMore: more,
      linksLoading: false
    });
  }
  handleUpdateFollowed(followed) {
    let more = followed.length === this.state.maxCount;
    let list = this.state.followed.concat(followed);
    this.setState({
      followed: list,
      followedHasMore: more,
      followedLoading: false
    });
  }
  handlePostFollow(type) {
    if(type==='follow') {
      this.getInstance().postFollow();
    } else if(type==='unfollow') {
      this.getInstance().postUnfollow();
    }
  }
  handleUpdateUserFollowing(val) {
    let user = this.state.user;
    if(user.relation===1 && val) {
      user.relation = 3;
    } else if(user.relation===2 && val) {
      user.relation = 4;
    } else if(user.relation===3 && !val) {
      user.relation = 1;
    } else if(user.relation===4 && !val) {
      user.relation = 2;
    }
    this.setState({user: user});
  }
  handleSetLoading(obj) {
    this.setState(obj);
  }
  handleClearData(key) {
    let newState = {};
    newState[key] = []
    this.setState(newState);
  }
}

export default alt.createStore(UserStore, 'UserStore');


// WEBPACK FOOTER //
// ./src/stores/UserStore.js